import { ConfirmationModalBase } from "@/components/common/modals";
import { useDeleteFlow } from "@/queries/flows/flows.api";
import { useToast } from "@elaniintc/goes-design-system";

interface Props {
  flowId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

const DeleteFlowModal = ({ flowId, isOpen, onClose }: Props) => {
  const { mutateAsync: deleteFlow, isPending } = useDeleteFlow();

  const { showToast } = useToast();

  const handleDeleteFlow = async (flowId: string) => {
    try {
      await deleteFlow(flowId);
      showToast({
        title: "Flujo eliminado",
        description: "El flujo ha sido eliminado correctamente.",
        options: {
          type: "success",
          duration: 5000,
        },
      });
      onClose();
    } catch (error) {
      console.error("Error deleting flow:", error);
      showToast({
        title: "Error",
        description: "Hubo un error al eliminar el flujo.",
        options: {
          type: "error",
          duration: 5000,
        },
      });
    }
  };

  return (
    <ConfirmationModalBase
      isOpen={isOpen}
      onClose={onClose}
      onAccept={() => {
        if (flowId) {
          handleDeleteFlow(flowId);
        }
      }}
      title="Eliminar flujo"
      description="¿Estás seguro de que deseas eliminar este flujo?"
      acceptText="Eliminar flujo"
      acceptVariant="danger-secondary"
      isLoading={isPending}
    />
  );
};

export default DeleteFlowModal;
